/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatachangeMultiData } from './datachangeMultiData';


/**
 * datachange the data that can be edited
 */
export interface DatachangeMultiDataEdit { 
    /**
     * primary Key (datachange_multi_set)
     */
    multiSetId: number;
    /**
     * the selection field of the data set (datachange_multi_metadata -> selection_field)
     */
    selectionField: string;
    multiData: Array<DatachangeMultiData>;
}

